import { AxiosHttpError, FormErrorsResponse, HttpErrorResponse } from './Http.types';

class HttpError implements HttpErrorResponse<FormErrorsResponse> {
  public readonly message: string;
  public readonly code: number | string;
  public readonly errors?: { form: FormErrorsResponse };
  /** The file is held by the antivirus scan (409); see features/media/media-scan.ts. */
  public readonly scanHeld: boolean;
  public readonly scanStatus?: string;

  constructor(error: AxiosHttpError) {
    this.message =
      error.response?.data.message ??
      error.response?.data.error ??
      error.message ??
      'Unknown error';
    this.code = error.response?.status ?? error.code ?? 0;
    this.errors = error.response?.data?.errors;
    this.scanHeld = error.response?.data?.scan_held === true;
    this.scanStatus = error.response?.data?.scan_status;
  }
}

export { HttpError };
